import { z } from 'zod';

import { LocationSchema } from './LocationSchema';
import { validateCoordinates, validateDestinationArea } from './validation-helpers';

export const GeographicalZoneAddressSchema = LocationSchema.extend({
  id: z.string().or(z.number())
}).superRefine((data, ctx) => {
  // Адресный элемент должен содержать хотя бы что-то (как зоны обслуживания)
  validateDestinationArea(data as any, ctx);
  // Координаты: либо обе заданы, либо обе пустые
  validateCoordinates(data, ctx);
});

